import "bootstrap/dist/css/bootstrap.min.css";
import { useEffect, useContext } from "react";
import { Form, Button, Card } from "react-bootstrap";
import { ClipboardCheck, PinMap, Save, Trash, XCircle, Book, ArrowRight, Building, Percent } from "react-bootstrap-icons";
import "./motivacion.css";
import municipiosYColonias from "../data/municipios.json";
import articulosData from "../data/articulos.json";
import { InfraccionesContext } from "../context/InfraccionesContext";
import Select from "react-select";

export default function Motivacion({ setActivePage }) {
    const { form, setForm } = useContext(InfraccionesContext);

    useEffect(() => {
        if (!form || Object.keys(form).length === 0) {
            setForm({
                motivo: "",
                articulos: [],
                calle: "",
                entreCalle: "",
                yCalle: "",
                municipio: "IXTAPALUCA",
                colonia: "",
                seRetuvo: [],
                cantidadUMAs: 0,
                cantidadDias: 0,
                nivelMulta: "media",
                incidencia: "Alta"
            });
        }
    }, [form, setForm]);

    useEffect(() => {
        const calcularResumenArticulos = (articulosSeleccionados) => {
            const resumen = {};
            const nivelSeleccionado = form.nivelMulta || "media";

            articulosSeleccionados.forEach((item) => {
                const clave = item.split(" - ")[0];
                const art = articulosData.find((a) => a.clave === clave);
                const valorNivel = Number(art?.[nivelSeleccionado]);
                const valor = Number.isFinite(valorNivel)
                    ? valorNivel
                    : Number(art?.media ?? art?.cantidad ?? 0);

                if (art && art.unidad && Number.isFinite(valor)) {
                    if (!resumen[art.unidad]) resumen[art.unidad] = 0;
                    resumen[art.unidad] += valor;
                }
            });

            return resumen;
        };

        const resumen = calcularResumenArticulos(form.articulos || []);
        const cantidadUMAs = resumen["UMA"] || 0;
        const cantidadDias = resumen["DIA"] || 0;

        setForm((prevForm) => ({
            ...prevForm,
            cantidadUMAs,
            cantidadDias
        }));
    }, [form.articulos, form.nivelMulta, setForm]);

    const validaciones = {
        motivo: value => value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ\s]/g, ''),
        nombre: value => value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ\s]/g, ''),
        colonia: value => value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ\s]/g, ''),
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        let nuevoValor = value;
        if (validaciones[name]) {
            nuevoValor = validaciones[name](value);
        }

        setForm({
            ...form,
            [name]: nuevoValor,
            ...(name === "municipio" ? { colonia: "" } : {})
        });
    };

    const handleCheckboxChange = (e) => {
        const { value, checked } = e.target;
        setForm((prevForm) => ({
            ...prevForm,
            seRetuvo: checked
                ? [...prevForm.seRetuvo, value]
                : prevForm.seRetuvo.filter((item) => item !== value),
        }));
    };

    const handleSave = () => {
        setForm(form);
        alert("Datos guardados temporalmente. Continúa con el siguiente paso.");
    };

    const handleClear = () => {
        if (window.confirm("¿Estás seguro de que deseas limpiar todos los campos?")) {
            setForm({
                motivo: "",
                articulos: [],
                calle: "",
                entreCalle: "",
                yCalle: "",
                municipio: "IXTAPALUCA",
                colonia: "",
                seRetuvo: [],
                cantidadUMAs: 0,
                cantidadDias: 0,
                nivelMulta: "media",
                incidencia: "Alta"
            });
        }
    };

    const handleNext = () => {
        setActivePage("infractor");
    };

    const handleCancel = () => {
        if (window.confirm("¿Seguro que deseas cancelar la infracción? Se eliminarán todos los datos.")) {
            setForm({
                motivo: "",
                articulos: [],
                calle: "",
                entreCalle: "",
                yCalle: "",
                municipio: "IXTAPALUCA",
                colonia: "",
                seRetuvo: [],
                cantidadUMAs: 0,
                cantidadDias: 0,
                nivelMulta: "media",
                incidencia: "Alta"
            });
            setActivePage("infracciones");
        }
    };

    return (
        <div className="motivacion-page">
            <div className="container">
            <h1 className="title">Motivación de la Infracción</h1>
            <div className="divider"></div>

            <Card className="info-card mb-6">
                <p>Los campos con asterisco (*) son obligatorios</p>
            </Card>

            <Form className="form-container">
                <Card className="mb-4 p-4">
                    <div className="form-group">
                        <label className="form-label">Motivo *</label>
                        <div className="input-group">
                            <span className="input-icon"><ClipboardCheck /></span>
                            <Form.Control
                                type="text"
                                placeholder="Motivo"
                                name="motivo"
                                value={form.motivo}
                                onChange={handleChange}
                                required
                            />
                        </div>
                    </div>

                    <div className="form-group">
                        <label className="form-label">Artículos relacionados *</label>

                        <div className="input-group">
                            <span className="input-icon"><Book /></span>
                            <div style={{ flex: 1 }}>
                                <Select
                                    options={articulosData.map((art) => ({
                                        value: `${art.clave} - ${art.descripcion}`,
                                        label: `[${art.relevancia || "Baja"}] ${art.clave} - ${art.descripcion}`,
                                    }))}
                                    isMulti
                                    closeMenuOnSelect={false}
                                    hideSelectedOptions={false}
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    value={(form.articulos || []).map((item) => {
                                        const parts = item.split(" - ");
                                        const clave = parts[0];
                                        const descripcion = parts.slice(1).join(" - ");
                                        return {
                                            value: item,
                                            label: `${clave} - ${descripcion}`,
                                        };
                                    })}
                                    onChange={(selectedOptions) => {
                                        const valores = selectedOptions ? selectedOptions.map((option) => option.value) : [];
                                        setForm({ ...form, articulos: valores });
                                    }}
                                    placeholder="Selecciona artículos"
                                    isSearchable
                                />
                            </div>
                        </div>
                    </div>

                    <div className="row mt-3">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label className="form-label">Nivel de multa *</label>
                                <Form.Select
                                    name="nivelMulta"
                                    value={form.nivelMulta || "media"}
                                    onChange={handleChange}
                                    required
                                >
                                    <option value="minima">Mínima</option>
                                    <option value="media">Media</option>
                                    <option value="maxima">Máxima</option>
                                </Form.Select>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="form-group">
                                <label className="form-label">Cantidad de UMAs</label>
                                <div className="input-group">
                                    <span className="input-icon"><Percent /></span>
                                    <Form.Control
                                        type="number"
                                        name="cantidadUMAs"
                                        value={form.cantidadUMAs || 0}
                                        disabled
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row mt-3">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label className="form-label">Incidencia *</label>
                                <Form.Select
                                    name="incidencia"
                                    value={form.incidencia || "Alta"}
                                    onChange={handleChange}
                                    required
                                >
                                    <option value="Alta">Alta</option>
                                    <option value="Media">Media</option>
                                    <option value="Baja">Baja</option>
                                </Form.Select>
                            </div>
                        </div>
                    </div>
                </Card>

                <Card className="mb-4 p-4">
                    <div className="row">
                        {[{
                            label: "Calle *", name: "calle", icon: <PinMap />, placeholder: "Calle"
                        },
                        {
                            label: "Entre Calle *", name: "entreCalle", icon: <PinMap />, placeholder: "Entre Calle"
                        },
                        {
                            label: "Y Calle *", name: "yCalle", icon: <PinMap />, placeholder: "Y Calle"
                        }].map((field, index) => (
                            <div key={index} className="col-md-4">
                                <div className="form-group">
                                    <label className="form-label">{field.label}</label>
                                    <div className="input-group">
                                        {field.icon && <span className="input-icon">{field.icon}</span>}
                                        <Form.Control
                                            type="text"
                                            placeholder={field.placeholder}
                                            name={field.name}
                                            value={form[field.name]}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                            </div>
                        ))}

                        <div className="col-md-6">
                            <div className="form-group">
                                <label className="form-label">Municipio *</label>
                                <div className="input-group">
                                    <span className="input-icon"><Building /></span>
                                    <Form.Control as="select" name="municipio" value={form.municipio} onChange={handleChange} required>
                                        <option value="">Seleccione un municipio</option>
                                        {Object.keys(municipiosYColonias).map((municipio, index) => (
                                            <option key={index} value={municipio}>{municipio}</option>
                                        ))}
                                    </Form.Control>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="form-group">
                                <label className="form-label">Colonia *</label>
                                <div className="input-group">
                                    <span className="input-icon"><Building /></span>
                                    <Form.Control as="select" name="colonia" value={form.colonia} onChange={handleChange} required disabled={!form.municipio}>
                                        <option value="">Seleccione una colonia</option>
                                        {form.municipio && municipiosYColonias[form.municipio].map((colonia, index) => (
                                            <option key={index} value={colonia}>{colonia}</option>
                                        ))}
                                    </Form.Control>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="form-group">
                        <label className="form-label">Se Retuvo *</label>
                        <div className="checkbox-group d-flex justify-content-between">
                            {["Licencia", "Placa", "Tarjeta de Circulación", "Vehículo"].map((item, index) => (
                                <div key={index} className="checkbox-item px-3">
                                    <Form.Check
                                        type="checkbox"
                                        label={<span style={{ fontSize: "1.2rem" }}>{item}</span>}
                                        value={item}
                                        checked={Array.isArray(form.seRetuvo) && form.seRetuvo.includes(item)}
                                        onChange={handleCheckboxChange}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                </Card>

                <div className="button-group">
                    <Button type="button" variant="primary" onClick={handleSave}><Save /> Guardar</Button>
                    <Button type="button" variant="success" onClick={handleNext}><ArrowRight /> Siguiente</Button>
                    <Button type="button" variant="secondary" onClick={handleClear}><Trash /> Limpiar</Button>
                    <Button type="button" variant="danger" onClick={handleCancel}><XCircle /> Cancelar</Button>
                </div>
            </Form>
            </div>
        </div>
    );
}